import Network from './network';

export default {
  get(startingAfter, args) {
    const queryParams = new URLSearchParams();
    if (startingAfter) queryParams.append('starting_after', startingAfter);
    Network.get(`/billing/invoices?${queryParams.toString()}`, args);
  },
};
